import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Phone, Mail, Clock } from "lucide-react";
import { useLang } from "../lib/LangContext";
import { waLink, WHATSAPP_DISPLAY, SUPPORT_EMAIL } from "../lib/mock";
import { SUPPORT } from "../constants/testIds";

export const Support = () => {
  const { t } = useLang();
  return (
    <section
      id="support"
      className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto py-20 md:py-28"
    >
      <div className="rounded-3xl bg-lokam-forest text-lokam-cream relative overflow-hidden">
        {/* Tangerine ribbon */}
        <div
          aria-hidden
          className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-lokam-tangerine/30 blur-3xl"
        />
        <div
          aria-hidden
          className="absolute -bottom-32 -left-20 h-80 w-80 rounded-full bg-lokam-whatsapp/15 blur-3xl"
        />

        <div className="relative px-6 md:px-12 lg:px-16 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-lokam-tangerine">
              {t.support.eyebrow}
            </p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-balance">
              {t.support.title}
            </h2>
            <p className="mt-5 max-w-xl text-base md:text-lg text-lokam-cream/75 leading-relaxed">
              {t.support.subtitle}
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm text-lokam-cream/80">
              <Clock className="h-4 w-4 text-lokam-tangerine" />
              {t.support.hours}
            </div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={SUPPORT.whatsappBtn}
              className="group rounded-2xl bg-lokam-whatsapp hover:bg-lokam-whatsapp-dark p-6 transition-colors flex flex-col gap-3"
            >
              <FaWhatsapp className="h-7 w-7" />
              <div>
                <div className="font-display font-semibold text-lg">{t.support.whatsapp}</div>
                <div className="text-xs text-white/85 mt-1">{WHATSAPP_DISPLAY}</div>
              </div>
            </a>

            <a
              href="tel:+918299548152"
              data-testid={SUPPORT.callBtn}
              className="group rounded-2xl bg-lokam-forest-soft hover:bg-lokam-forest-soft/80 border border-white/10 p-6 transition-colors flex flex-col gap-3"
            >
              <Phone className="h-7 w-7 text-lokam-tangerine" />
              <div>
                <div className="font-display font-semibold text-lg">{t.support.call}</div>
                <div className="text-xs text-lokam-cream/75 mt-1">{WHATSAPP_DISPLAY}</div>
              </div>
            </a>

            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid={SUPPORT.emailBtn}
              className="group rounded-2xl bg-lokam-forest-soft hover:bg-lokam-forest-soft/80 border border-white/10 p-6 transition-colors flex flex-col gap-3"
            >
              <Mail className="h-7 w-7 text-lokam-tangerine" />
              <div>
                <div className="font-display font-semibold text-lg">{t.support.email}</div>
                <div className="text-xs text-lokam-cream/75 mt-1">{SUPPORT_EMAIL}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
